import client from '../httpClient';

const libraryGetSpecifyDirctoryApi = (pathParameter, params) => {
  return client.get(`/libraries/from-directories/${pathParameter}`, { params });
};

export default libraryGetSpecifyDirctoryApi;
